// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3mcus","inputWrap":"CustomTip_inputWrap__TurGk"};